import PropTypes, { number } from "prop-types";
import React, { useState, useEffect } from "react";
import { Collapse, Modal, Table, Row, Col } from "reactstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import classname from "classnames";
import "../../assets/css/Layout/Header.css";
//i18n
import { withTranslation } from "react-i18next";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import { connect } from "react-redux";
import axios from "axios";
import configure from "configure";
import Select from "react-select";
import { isNaN } from "lodash";
import Loader from "pages/Separate/Loader";
import ReactSelect from "react-select";
import { fetchNodeData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import VerionHistory from "./Version/versionHistory";

const Navbar = (props) => {
  const [expense, setExpense] = useState(false);
  const [margin, setMargin] = useState({ value: 1.5, label: 1.5 });
  const [marginOption, setMarginOption] = useState([
    {
      value: 1.5,
      label: 1.5,
    },
    {
      value: 2,
      label: 2,
    },
    {
      value: 2.5,
      label: 2.5,
    },
  ]);
  const [dashboard, setdashboard] = useState(false);
  const [setting, setSetting] = useState(false);
  const [allcurrency, setAllCurrency] = useState([]);
  const [allTechData, setAllTechData] = useState([]);
  const [currency, setCurrency] = useState({
    label: "INR",
    value: "INR",
    symbol: "₹",
  });
  const [addCallingModal, setAddCallingModal] = useState(false);
  const [fixedContent, setFixedContent] = useState(false);

  const [isLoading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  const [subTotal, setSubTotal] = useState(0);
  const [profit, setProfit] = useState("");
  const [finalCost, setFinalCost] = useState(0);

  useEffect(() => {
    RolesPermission();
    // fetchCurrency()
  }, []);
  const handleChange = (selectedOption) => {
    setMargin(selectedOption);
  };

  useEffect(() => {
    const tempData = [...allTechData];
    setAllTechData(
      tempData.map((tech) => ({
        ...tech,
        estimate_cost: tech.days * tech[currency.value],
      })),
    );
  }, [currency, margin]);

  useEffect(() => {
    setSubTotal(allTechData.reduce((acc, curr) => acc + curr.estimate_cost, 0));
  }, [allTechData]);

  useEffect(() => {
    setFinalCost(subTotal + (subTotal * profit) / 100);
  }, [subTotal]);

  const fetchCurrency = async () => {
    setLoading(true);
    setAddCallingModal(true);

    try {
      await axios({
        method: "get",
        url: `${configure.apiUrl}/currency`,

        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLoading(false);
        setAllCurrency(
          res.data.data.currency.map((curr) => ({
            label: curr.currency,
            value: curr.currency,
            symbol: curr.symbol,
          })),
        );

        // call show technologies api
        showTechnologiesData();
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const showTechnologiesData = async () => {
    setLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/show_technologies`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(async (response) => {
        if (response.data.data.length > 0) {
          const datas = JSON.parse(response.data.data[0].currency_value);

          setAllTechData(
            datas.map((data) => ({
              ...data,
              days: "",
              estimate_cost: 0,
            })),
          );
        }
        setAddCallingModal(true);
        setLoading(false);
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangeDays = (value, index) => {
    const tempData = [...allTechData];

    setAllTechData(
      tempData.map((tech, i) => {
        if (i == index) {
          tech.days = value;
          tech.estimate_cost = value * tech[currency.value];
        }
        return tech;
      }),
    );
  };

  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "white",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 50,
    }),
  };

  const RolesPermission = async (e) => {
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("auth_id"));
    setLoading(true);
    try {
      const response = await axios({
        method: "post",
        url: `${configure.apiUrl}/staff_roles`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }).then((response) => {
        setRoles(response.data.data.map((item) => JSON.parse(item.permission)));
        setLoading(false);
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  function filterInnerArraysById(id) {
    return roles.map((innerArray) => {
      return innerArray.filter((element) => {
        const parts = element.split(",");
        const elementId = parseInt(parts[0]);
        return elementId === id;
      });
    });
  }

  const ids = [3, 24, 4, 5, 6];

  const output = roles.map((innerArray) =>
    innerArray.filter((element) => {
      const parts = element.split(",");
      const elementId = parseInt(parts[0]);
      return ids.includes(elementId);
    }),
  );
  const output2 = output.map((innerArray) => {
    const element = innerArray[1]; // Get the element at index 2 (0-based indexing)
    const parts = element.split(",");
    return parts.map((part) => parseInt(part)); // Convert to integers
  });

  const calenderUrl = useLocation();

  const calender3 = calenderUrl.pathname;
  const usepara = useParams();
  const filterRole =
    localStorage.getItem("auth_role") == 1 ||
      localStorage.getItem("auth_role") == 11 ||
      localStorage.getItem("auth_role") == 4
      ? true
      : false;

  const [shouldShow, setShouldShow] = useState(false);
  const token = secureLocalStorage.getItem("auth_token");
  const [modalOpen, setModalOpen] = useState(false);
  const [boxWidth, setBoxWidth] = useState(0);
  const [news, setNews] = useState("");
  const [versions, setVersions] = useState([]);
  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.95);
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  useEffect(() => {
    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();

    const isTuesdayOrThursday = day === 2 || day === 4;
    const isAfter3PM = hour >= 15;

    if (isTuesdayOrThursday && isAfter3PM) {
      const fetchCurrentVersion = async () => {
        try {
          const res = await fetchNodeData(() => { }, "currentVersion", token);
          if (res?.success) {
            const today = new Date();
            const todayStr = today.toISOString().split("T")[0];
            setNews(
              res.data.updateType == "new module"
                ? "🔥 Huge Release Dropped! New modules, fixes & more – check the log."
                : res.data.updateType == "updation"
                  ? "✨ New Features Unlocked! See what’s changed in today’s update."
                  : res.data.updateType == "bug fix"
                    ? "🚨 Bug Fix Alert! We’ve rolled out updates – check if your issue is fixed."
                    : "🚀 Today’s the Day! Discover Our Exciting New Release – Now Live! Experience Innovation at Its Best. 🌟",
            );
            if (res?.data.date == todayStr) {
              setShouldShow(true);
            }
          }
        } catch (err) {
          console.error("Failed to fetch current version:", err);
        }
      };
      fetchCurrentVersion();
    }
  }, []);

  const handleOpenModal = async () => {
    try {
      const res = await fetchNodeData(() => { }, "versionControl/");
      if (res.success && res.data) {
        setVersions(res.data.versionData || []);
        setModalOpen(true);
      }
    } catch (err) {
      console.error("Failed to fetch version history:", err);
    }
  };

  return (
    <React.Fragment>
      <div
        className={`topnav ps-1 pe-0 ${calender3 === `${configure.appUrl}calendar` ||
          calender3 === `${configure.appUrl}calender/${usepara.id}` ||
          calender3 === `${configure.appUrl}knowledge-documents`
          ? "d-none"
          : ""
          }`}
        style={{ zIndex: "1001" }}
      >
        <div className="container-fluid px-0">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav d-flex justify-content-between w-100">
                <div className="d-flex">
                  {/* dashboard */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${configure.appUrl}dashboard`}
                    >
                      <i className="bx bx-home-circle me-2 "></i>
                      {props.t("Dashboard")} {props.menuOpen}
                    </Link>
                  </li>

                  {/* Work MODULE  */}
                  {filterInnerArraysById(4)
                    .map((item) => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <>
                      {/* Development Project */}
                      {filterInnerArraysById(25)
                        .map((item) => item[0]?.split(",").map(Number)[2])
                        .includes(1) == true ? (
                        <li className="nav-item dropdown">
                          <a
                            className="nav-link dropdown-toggle arrow-none"
                            id="topnav-more"
                            type="button"
                            onClick={() => toggleMenu(6)}
                          >
                            <i className="fa fa-code me-2"></i>
                            <span key="t-extra-pages">Development</span>
                            <span className="arrow-down"></span>
                          </a>
                          <div
                            className={`dropdown-menu active`}
                            aria-labelledby="topnav-more"
                          >
                            {filterInnerArraysById(25)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                className="dropdown-item dropdown-toggle arrow-none"
                                to={`${configure.appUrl}weekly-plan/development`}
                                id="topnav-invoice"
                                role="button"
                              >
                                <span key="t-invoices">Weekly Plan</span>
                              </Link>
                            ) : null}

                            {filterInnerArraysById(88)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                className="dropdown-item dropdown-toggle arrow-none"
                                to={`${configure.appUrl}initial-project-plan/development`}
                                id="topnav-invoice"
                                role="button"
                              >
                                <span>Initial Project Plan</span>
                              </Link>
                            ) : null}

                            {filterInnerArraysById(25)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                className="dropdown-item dropdown-toggle arrow-none"
                                to={`${configure.appUrl}work/projects`}
                                id="topnav-invoice"
                                role="button"
                              >
                                <span>Projects</span>
                              </Link>
                            ) : null}

                          </div>
                        </li>
                      ) : null}


                      {/* Digital Marketing */}
                      {filterInnerArraysById(97)
                        .map((item) => item[0]?.split(",").map(Number)[2])
                        .includes(1) == true ? (
                        <li className="nav-item dropdown">
                          <a
                            className="nav-link dropdown-toggle arrow-none"
                            id="topnav-more"
                            type="button"
                            onClick={() => toggleMenu(6)}
                          >
                            <i className="fa fa-bullhorn me-2"></i>
                            <span key="t-extra-pages">Digital Marketing</span>
                            <span className="arrow-down"></span>
                          </a>
                          <div
                            className={`dropdown-menu active`}
                            aria-labelledby="topnav-more"
                          >
                            <Link
                              className="dropdown-item dropdown-toggle arrow-none"
                              to={`${configure.appUrl}weekly-plan/digital-marketing`}
                              id="topnav-invoice"
                              role="button"
                            >
                              <span key="t-invoices">My Weekly Plan</span>
                            </Link>

                            <Link
                              className="dropdown-item dropdown-toggle arrow-none"
                              to={`${configure.appUrl}monthly-planning`}
                              id="topnav-invoice"
                              role="button"
                            >
                              <span>Monthly Planning</span>
                            </Link>

                            {filterInnerArraysById(105)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                className="dropdown-item dropdown-toggle arrow-none"
                                to={`${configure.appUrl}monthly-approval`}
                                id="topnav-invoice"
                                role="button"
                              >
                                <span>Monthly Approval</span>
                              </Link>
                            ) : null}

                            {filterInnerArraysById(98)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                className="dropdown-item dropdown-toggle arrow-none"
                                to={`${configure.appUrl}teams-weekly-plan/digital-marketing`}
                                id="topnav-invoice"
                                role="button"
                              >
                                <span key="t-invoices">Teams Weekly Plan</span>
                              </Link>
                            ) : null}

                            {filterInnerArraysById(99)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                className="dropdown-item dropdown-toggle arrow-none"
                                to={`${configure.appUrl}project-weekly-plan/digital-marketing`}
                                id="topnav-invoice"
                                role="button"
                              >
                                <span>Project Weekly Plan</span>
                              </Link>
                            ) : null}

                            {filterInnerArraysById(100)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                className="dropdown-item dropdown-toggle arrow-none"
                                to={`${configure.appUrl}initial-project-plan/digital-marketing`}
                                id="topnav-invoice"
                                role="button"
                              >
                                <span>Initial Project Plan</span>
                              </Link>
                            ) : null}

                            {filterInnerArraysById(101)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                className="dropdown-item dropdown-toggle arrow-none"
                                to={`${configure.appUrl}work/digital_marketing`}
                                id="topnav-invoice"
                                role="button"
                              >
                                <span>Projects</span>
                              </Link>
                            ) : null}
                          </div>
                        </li>
                      ) : null}


                      {/* Support */}
                      {filterInnerArraysById(107)
                        .map((item) => item[0]?.split(",").map(Number)[2])
                        .includes(1) == true ? (
                        <li className="nav-item dropdown">
                          <a
                            className="nav-link dropdown-toggle arrow-none"
                            id="topnav-more"
                            type="button"
                          >
                            <i className="fa fa-life-ring me-2"></i>
                            <span key="t-extra-pages">Support</span>
                            <span className="arrow-down"></span>
                          </a>
                          <div
                            className={`dropdown-menu active`}
                            aria-labelledby="topnav-more"
                          >
                            <Link
                              className="dropdown-item dropdown-toggle arrow-none"
                              to={`${configure.appUrl}support/ticket`}
                              id="topnav-invoice"
                              role="button"
                            >
                              <span key="t-invoices">Tickets</span>
                            </Link>

                            <Link
                              className="dropdown-item dropdown-toggle arrow-none"
                              to={`${configure.appUrl}support/test-cases`}
                              id="topnav-invoice"
                              role="button"
                            >
                              <span>Test Cases</span>
                            </Link>

                          </div>
                        </li>
                      ) : null}


                      {filterInnerArraysById(26)
                        .map((item) => item[0]?.split(",").map(Number)[2])
                        .includes(1) == true ? (
                        <li className="nav-item dropdown">
                          <Link
                            className="nav-link dropdown-toggle arrow-none text-dark"
                            to={`${configure.appUrl}work/activities`}
                          >
                            <i className="fa fa-tasks me-2 "></i>
                            {props.t("Activities")} {props.menuOpen}
                          </Link>
                        </li>
                      ) : null}

                      {filterInnerArraysById(29)
                        .map((item) => item[0]?.split(",").map(Number)[2])
                        .includes(1) == true ? (
                        <li className="nav-item dropdown">
                          <Link
                            className="nav-link dropdown-toggle arrow-none text-dark"
                            to={`${configure.appUrl}work/hosting`}
                          >
                            <i className="fa fa-server me-2 "></i>
                            {props.t("Hosting")} {props.menuOpen}
                          </Link>
                        </li>
                      ) : null}
                    </>
                  ) : null}


                  {/* Reports */}
                  {filterInnerArraysById(6)
                    .map((item) => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle arrow-none"
                        id="topnav-more"
                        type="button"
                        onClick={() => toggleMenu(6)}
                      >
                        <i className="fa fa-chart-bar me-2"></i>
                        <span key="t-extra-pages">Reports</span>
                        <span className="arrow-down"></span>
                      </a>
                      <div
                        className={`dropdown-menu active`}
                        aria-labelledby="topnav-more"
                      >
                        {filterInnerArraysById(96)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}flaws-gap`}
                            id="topnav-invoice"
                            role="button"
                          >
                            <span key="t-invoices">Flaws & Gaps</span>
                          </Link>
                        ) : null}

                        {filterInnerArraysById(118)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}seo-report`}
                            id="topnav-invoice"
                            role="button"
                          >
                            <span>Seo Report</span>
                          </Link>
                        ) : null}

                        {filterInnerArraysById(32)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}timesheet-report`}
                            id="topnav-invoice"
                            role="button"
                          >
                            <span>Timesheet Report</span>
                          </Link>
                        ) : null}

                      </div>
                    </li>
                  ) : null}
                </div>

                {/* end modules  */}
                <div className="d-flex gap-3 align-items-center">

                  {filterInnerArraysById(7)
                    .map(item => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <div
                        className=" dropdown-toggle cursor-pointer p-0 border-0 bg-transparent "
                        id="topnav-more"
                        onClick={() => toggleMenu(3)}
                      >
                        <i
                          className="fa fa-globe "
                          style={{ fontSize: "12px" }}
                        ></i>
                      </div>
                      <div
                        className={`dropdown-menu settings-dropdown-menu overflow-hidden `}
                        aria-labelledby="topnav-more" 
                      >
                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`https://mars.zithas.in`}
                          target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>CRM</span>
                        </a>

                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`https://hr.zithas.in/`}
                          target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>HR</span>

                        </a>

                        {/* <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`https://accounts.zithas.in`}
                          // target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>Finance India</span>
                        </a>

                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`https://accounts.zithas.com`}
                          // target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>Finance USA</span>
                        </a> */}

                      </div>
                    </li>
                  ) : null}

                  {/* setting  */}
                  {filterInnerArraysById(13)
                    .map((item) => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <Link className="nav-link dropdown-toggle arrow-none text-dark mt-1 p-0">
                        <i className="bx bx-cog setting-icon"></i>
                      </Link>
                      <div
                        className={classname("dropdown-menu settings-dropdown-menu", {
                          show: setting,
                        })}
                      >
                        <div className="row flex-wrap py-2 overflow-hidden">


                          <div className="col-md-3">
                            <h6 className="ps-4 mt-2 fw-bold">Work</h6>
                            {filterInnerArraysById(83)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <li>
                                <Link
                                  to={`${configure.appUrl}setting/industry`}
                                  className="dropdown-item"
                                >
                                  {props.t("Industry")}
                                </Link>
                              </li>
                            ) : null}

                            {filterInnerArraysById(81)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <li>
                                <Link
                                  to={`${configure.appUrl}setting/knowledge-base`}
                                  className="dropdown-item"
                                >
                                  {props.t("Knowledge Base")}
                                </Link>
                              </li>
                            ) : null}

                            <li>
                              {filterInnerArraysById(83)
                                .map(
                                  (item) => item[0]?.split(",").map(Number)[2],
                                )
                                .includes(1) == true ? (
                                <Link
                                  to={`${configure.appUrl}setting/digital_marketing`}
                                  className="dropdown-item"
                                >
                                  {props.t("Digital Marketing")}
                                </Link>
                              ) : null}
                            </li>

                            <li>
                              {filterInnerArraysById(82)
                                .map(
                                  (item) => item[0]?.split(",").map(Number)[2],
                                )
                                .includes(1) == true ? (
                                <Link
                                  to={`${configure.appUrl}setting/hosting`}
                                  className="dropdown-item"
                                >
                                  {props.t("Hosting")}
                                </Link>
                              ) : null}
                            </li>
                          </div>

                          {/* <div className="col-md-3">
                            <h6 className="ps-4 mt-2 fw-bold">Setting</h6>
                            <li>
                              {filterInnerArraysById(70)
                                .map(
                                  (item) => item[0]?.split(",")?.map(Number)[2],
                                )
                                .includes(1) == true ? (
                                <Link
                                  to={`${configure.appUrl}setting/companysetting`}
                                  className="dropdown-item"
                                >
                                  {props.t("Company Setting")}
                                </Link>
                              ) : null}
                            </li>

                            {filterInnerArraysById(73)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <li>
                                <Link
                                  to={`${configure.appUrl}setting/generalsetting`}
                                  className="dropdown-item"
                                >
                                  {props.t("General Setting")}
                                </Link>
                              </li>
                            ) : null}
                          </div> */}
                        </div>
                      </div>
                    </li>
                  ) : null}

                  {/* credentials  */}
                  <li className="nav-item dropdown">
                    {filterInnerArraysById(10)
                      .map((item) => item[0]?.split(",")?.map(Number)[2])
                      .includes(1) == true ? (
                      <Link
                        to={`${configure.appUrl}credentials`}
                        className="border-radius border-0 btn text-dark fs-5 ps-0 mt-1"
                        title="Credentials"
                      >
                        <i className="fa fa-address-card"></i>
                      </Link>
                    ) : null}
                  </li>

                </div>
              </ul>
            </Collapse>
          </nav>
        </div>
        <div>
          {shouldShow ? (
            <div
              className="marquee-container cursor-pointer"
              onClick={() => handleOpenModal()}
            >
              <div className="marquee-text">
                <div className="container-fluid">
                  <div className="d-flex justify-content-center gap-3">
                    <span>{news}</span>
                    <span className="blink-soft">
                      Click Here{" "}
                      <i className="mdi mdi-cursor-default-click PPC-color"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>

      <div className={`note-sticky-form ${modalOpen ? "d-block" : "d-none"}`}>
        <Draggable handle=".modal-header" cancel=".modal-body">
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "6%",
              right: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
              maxHeight: "fit-content",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">Version History</h5>
              <button
                type="button"
                onClick={() => setModalOpen(false)}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>
            <VerionHistory versions={versions} />
          </ResizableBox>
        </Draggable>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar)),
);
